import { api } from '@/lib/api';
import type {
  DayCareCaseListItem,
  DayCareProcedure,
  DayCareResource,
  DayCareStatus,
  CreateDayCareCasePayload,
} from '@/types/daycare';

export const dayCareApi = {
  createCase: (data: CreateDayCareCasePayload) =>
    api.post<{ message: string; data: DayCareCaseListItem }>('/api/daycare/cases', data),

  getCases: (params: { date?: string; status?: DayCareStatus; doctorId?: string } = {}) =>
    api.get<{ message: string; data: DayCareCaseListItem[] }>('/api/daycare/cases', { params }),

  getCaseById: (id: string) =>
    api.get<{ message: string; data: any }>(`/api/daycare/cases/${id}`),

  updateStatus: (id: string, toStatus: DayCareStatus, reason?: string) =>
    api.patch<{ message: string; data: DayCareCaseListItem }>(`/api/daycare/cases/${id}/status`, {
      toStatus,
      reason,
    }),

  getOrCreateBill: (caseId: string) =>
    api.post<{ message: string; data: any }>(`/api/daycare/cases/${caseId}/bill`, {}),

  listProcedures: (params?: { departmentId?: string; includeInactive?: boolean }) =>
    api.get<{ message: string; data: DayCareProcedure[] }>('/api/daycare/procedures', {
      params: params ? { ...params, includeInactive: params.includeInactive ? 'true' : undefined } : {},
    }),

  createProcedure: (data: { name: string; departmentId: string; defaultDurationMinutes?: number; baseCharge: number }) =>
    api.post<{ message: string; data: DayCareProcedure }>('/api/daycare/procedures', data),

  updateProcedure: (id: string, data: Partial<{ name: string; departmentId: string; defaultDurationMinutes?: number | null; baseCharge: number; isActive: boolean }>) =>
    api.patch<{ message: string; data: DayCareProcedure }>(`/api/daycare/procedures/${id}`, data),

  deleteProcedure: (id: string) =>
    api.delete<{ message: string; data: null }>(`/api/daycare/procedures/${id}`),

  listResources: (params?: { departmentId?: string; type?: string; includeInactive?: boolean }) =>
    api.get<{ message: string; data: DayCareResource[] }>('/api/daycare/resources', {
      params: params ? { ...params, includeInactive: params.includeInactive ? 'true' : undefined } : {},
    }),

  createResource: (data: { name: string; type: string; departmentId: string }) =>
    api.post<{ message: string; data: DayCareResource }>('/api/daycare/resources', data),

  updateResource: (id: string, data: Partial<{ name: string; type: string; departmentId: string; isActive: boolean }>) =>
    api.patch<{ message: string; data: DayCareResource }>(`/api/daycare/resources/${id}`, data),

  deleteResource: (id: string) =>
    api.delete<{ message: string; data: null }>(`/api/daycare/resources/${id}`),
};

